import { createApi } from "@reduxjs/toolkit/dist/query/react"
import { apiQuery } from "../../utils/api-config";
import { ResponsePermission } from "../../types/auth/ResponsePermission";
import { Response, ResponseInitialize } from "../../types/init/ResponseInitialize";
import { IntegrationStatus } from "../../types/init/IntegrationStatus";

export const configurationApi = createApi({
    reducerPath: "permission",
    baseQuery: apiQuery,
    tagTypes: ["permissions", "initial", "status"],
    endpoints: builder => ({
        // Получение
        getPermissions: builder.query<ResponsePermission, void>({
            query: () => '/configurations/permissions',
            providesTags: ["permissions"]
        }),
        getInitialization: builder.query<ResponseInitialize, Partial<void>>({
            query: () => '/configurations/initialize',
            providesTags: ["initial"]
        }),
        getIntegrationStatus: builder.query<Response<IntegrationStatus>, Partial<void>>({
            query: () => '/configurations/integration/status',
            providesTags: ["status"]
        }),
        updateIntegrationStatus: builder.mutation<void, Partial<IntegrationStatus>>({
            query: (body) => ({
                url: "/configurations/integration/status",
                method: "PUT",
                body
            }),
            invalidatesTags: ["status"]
        }),
        syncData: builder.mutation<ResponseInitialize, Partial<void>>({
            query: () => ({
                url: '/configurations/sync',
                method: "POST"
            }),
            invalidatesTags: ["initial"]
        }),

    })
})

export const {
    useGetPermissionsQuery,
    useGetInitializationQuery,
    useSyncDataMutation,
    useGetIntegrationStatusQuery,
    useUpdateIntegrationStatusMutation,
} = configurationApi
